module.exports = __webpack_public_path__ + "static/media/HomeRoll_Roof_AluCladRoof.062661fd.jpg";